<template>
    <div>
        <v-select
            v-model="user"
            ref="userSelect"
            label="UserId"
            :filterable="false"
            :resetOnOptionsChange="resetOnOptionsChange"
            :multiple="multiple"
            @search="onSearch"
            @input="onChange"
            :options="options"
            :value="selectedValues"
            :placeholder="`Search ${placeholder}`"
            :class="{'filter-select': forFilters, 'is-invalid': hasError, 'is-multiple': multiple, 'is-single': !multiple}">
            <template slot="no-options">
                Search for a User by Name or Email
            </template>
            <template slot="option" slot-scope="option">
                <div class="d-center">
                    {{ option.FirstName }} {{ option.LastName }} <template v-if="option.email">({{ option.email }})</template>
                    <template v-if="option.subcontractor_name">
                        - {{ option.subcontractor_name }}
                    </template>
                </div>
            </template>
            <template slot="selected-option" slot-scope="option">
                <div class="selected d-center">
                    {{ option.FirstName }} {{ option.LastName }} <template v-if="option.email">({{ option.email }})</template>
                </div>
            </template>
        </v-select>
    </div>
</template>

<script>
    export default {
        props: {
            selectedValues: {
                type: Object,
                default: null
            },

            forFilters: {
                type: Boolean,
                default: false,
            },

            // excludeId: {
            //     type: Number,
            // },

            placeholder: {
                type: String,
                default: 'Users',
            },

            hasError: {
                type: Boolean,
                default: false,
            },

            resetOnOptionsChange: {
                type: Boolean,
                default: false,
            },

            multiple: {
                type: Boolean,
                default: false,
            },

            filters: {
                type: Object,
                default: null
            },

            appendCurrentUserOption: {
                type: Boolean,
                default: false,
            },
        },

        data: function() {
            return {
                options: [],
                user: null,
            }
        },

        watch: {
            //Watcher for errors
            hasError(newValue, oldValue){
                //Set it
                this.hasError = newValue;
            },

            selectedValues(newValue, oldValue){
                if(newValue != null && Object.keys(newValue).length > 0 && !this.user)
                {
                    this.options.push(newValue);
                    this.user = newValue;
                }
            }
        },

        methods: {
            //Search
            onSearch: function(searchTerm, searchLoading){
                //Done loading
                searchLoading(true);

                //Send it
                this.$http.get('/users/search', {term: searchTerm, filters: this.filters})
                    .then(res => {
                        //Check Results
                        if(this.appendCurrentUserOption)
                        {
                            var currentUserOpt = [{
                                UserId: 'current_user',
                                FirstName: 'Current',
                                LastName: 'User',
                                email: 'Filters on the Current Logged in User',
                            }];

                            //Set the data
                            this.options = currentUserOpt.concat(res.data);
                        }
                        else
                        {
                            //Set the data
                            this.options = res.data;
                        }

                        //Done loading
                        searchLoading(false);
                    });
            },

            onChange: function (selected) {
                this.$emit('vuselected', this.user);
            },

            reset(){
                //Set to null
                this.user = null;
                this.options = [];
                this.$refs.userSelect.clearSelection();
            },

            setValue(user){
                this.options.push(user);
                this.user = user;
            },
        },

        mounted() {
            //Push the selected value. Null will default to the placeholder
            if(this.selectedValues != null && Object.keys(this.selectedValues).length > 0)
            {
                this.options.push(this.selectedValues);
                this.user = this.selectedValues;
            }
        }
    }
</script>

<style scoped>
    .filter-select {
        background-color: #fff;
    }

    .filter-select.open >>> .selected-tag {
        margin-top: 3px;
    }

    .filter-select >>> .dropdown-toggle {
        border: 1px solid #c6c6c6;
        max-height: 31px;
        margin-top: -1px;
        padding: 1px 0 3px 0;
    }

    .is-single.filter-select >>> .selected-tag {
        margin: 3px 0 0 0;
        padding-left: 5px;
        white-space: nowrap;
        overflow: hidden;
        width: 200px;
    }

    .filter-select >>> .vs__actions button {
        margin-top: 3px;
    }

    .is-multiple.filter-select >>> .selected-tag {
        font-size: 11px;
        height: 23px;
        margin: 2px 1px 0;
    }
</style>